<template lang="pug">
  .documents-container
    .columns
      .column.is-3(v-for="(file, index) in chunkFiles" :key="index")
        .file(:style="{ 'background-image': 'url(' + file.md + ')'}")
          .more(v-if="checkMore(index)" @click="limit = files.length")
            .file-option: span +{{files.length - chunkFiles.length}}
          a.download(v-if="hasAccess && !checkMore(index)" title="Download" :href="file.document" download)
            .file-option: .mdi.mdi-download
</template>
<script>
export default {
  name: 'Documents',
  data () {
    return {
      limit: 4
    }
  },
  methods: {
    checkMore (index) {
      return ((index + 1) === this.chunkFiles.length) && this.hasMore
    }
  },
  props: {
    files: {
      default: () => []
    },
    hasAccess: {
      default: false
    }
  },
  computed: {
    chunkFiles () {
      return this.files.slice(0, this.limit)
    },
    hasMore () {
      return Boolean(this.files.length - this.chunkFiles.length)
    }
  }
}
</script>
<style lang="scss">
  .documents-container {
    margin-top: 18px;
    .columns {
      flex-wrap: wrap;
    }
    .file {
      background-position: center;
      background-color: aliceblue;
      border: 1px solid #919ba5;
      padding: 1.25rem;
      border-radius: 0;
      height: 150px;
      background-size: contain;
      background-repeat: no-repeat;
      button.delete {
        position: absolute;
        &::before {
          width: 10px;
        }
      }
      .more, .download {
        cursor: pointer;
        width: 100%;
        height: 100%;
        position: absolute;
        margin: -1.25rem;
        background-color: rgba(0, 0, 0, 0.2);
        .file-option {
          position: absolute;
          left: 50%;
          top: 50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          text-align: center;
          span {
            font-size: 26px;
          }
          .mdi-download {
            color: #4a4a4a;
            font-size: 64px;
          }
        }
      }
      .download {
        opacity: 0;
        background-color: transparent;
        &:hover {
          opacity: 1;
          background-color: rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cv/parts/profile/parts/documents/index.vue